<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <BankingDetails></BankingDetails>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import BankingDetails from "../../components/audit/BankingDetails.vue";

export default {
    components: {
        BankingDetails
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
